import { Routes } from '@angular/router';
import { LoginComponent } from './auth/components/login-component/login-component';
import { SidebarComponent } from './components/sidebar-component/sidebar-component';
import { authGuard, loggedGuardGuard } from './auth/guards/auth-guard';
import { HomeComponent } from './components/home-component/home-component';
import { MainComponent } from './components/main-component/main-component';
import { CollaborateurComponent } from './collaborateur/component/collaborateur-component/collaborateur-component';
import { UserComponent } from './utilisateur/component/user-component';
import { ProfilComponent } from './auth/components/profil-component/profil-component';
import { CompagnieComponent } from './compagnie/component/compagnie-component';
import { CollaborateurDetailsComponent } from './collaborateur/component/collaborateur-details-component/collaborateur-details-component';
import { AssureComponent } from './assurer/components/assure-component/assure-component';
import { AssureDetailComponent } from './assurer/components/assure-detail-component/assure-detail-component';
import { DistributionComponent } from './distribution/distribution-component/distribution-component';
import { SiteDetailComponent } from './site/component/site-detail-component/site-detail-component';
import { SiteComponent } from './site/component/site-component/site-component';
import { AvenantComponent } from './avenant/component/avenant-component/avenant-component';
import { EtatDocuments } from './etat-documents/etat-documents';
import { offlineGuard } from './shared/guards/offline-guard';
import { RapportSuiviComponent } from './admin/components/rapport-suivi/rapport-suivi-component';
import { ValidationSuiviComponent } from './admin/components/validation-suivi-component/validation-suivi-component';
import { ValidationSuiviDetailsComponent } from './admin/components/validation-suivi-details/validation-suivi-details-component';
import { GroupeComponent } from './Groupe/component/groupe-component/groupe-component';
import { RenvoiCompagnie } from './admin/components/renvoi-compagnie/renvoi-compagnie';
import { StockComponent } from './distribution/stock-component/stock-component';
import { StockGroupeComponent } from './distribution/stock-groupe-component/stock-groupe-component';

export const routes: Routes = [
  {path : 'login', component: LoginComponent, canActivate:[loggedGuardGuard]},
  {
    path : '',
    component : MainComponent,
    canActivateChild : [authGuard],
    children : [
      {path : 'home', component : HomeComponent},
      {path : 'collaborateurs', component : CollaborateurComponent, canActivate : [offlineGuard]},
      {path : 'collaborateurs/:id', component : CollaborateurDetailsComponent, canActivate : [offlineGuard]},
      {path : 'bureaux', component : SiteComponent, canActivate : [offlineGuard]},
      {path : 'bureaux/:id', component : SiteDetailComponent, canActivate : [offlineGuard]},
      {path : 'users', component : UserComponent, canActivate : [offlineGuard]},
      {path : 'profil', component : ProfilComponent, canActivate : [offlineGuard]},
      {path : 'compagnie', component : CompagnieComponent, canActivate : [offlineGuard]},
      {path : 'assure', component : AssureComponent},
      {path : 'assure/:id', component : AssureDetailComponent},
      {path : 'distribution', component : DistributionComponent, canActivate : [offlineGuard]},
      {path : 'avenant', component : AvenantComponent, canActivate : [offlineGuard]},
      {path : 'document_details/:state', component : EtatDocuments, canActivate : [offlineGuard]},
      {path : 'rapport_suivi', component : RapportSuiviComponent, canActivate : [offlineGuard]},
      {path : 'suivi/:slug', component : ValidationSuiviComponent, canActivate : [offlineGuard]},
      {path : 'suivi/:slug/:id', component : ValidationSuiviDetailsComponent, canActivate : [offlineGuard]},
      {path : 'groupes', component : GroupeComponent, canActivate : [offlineGuard]},
      {path : 'renvoi_compagnie', component : RenvoiCompagnie, canActivate : [offlineGuard]},
      {path : 'stock_groupes', component : StockGroupeComponent, canActivate : [offlineGuard]}, 
      {path : 'stock_sites', component : StockComponent, canActivate : [offlineGuard]}, 


      {path : '', redirectTo : '/home', pathMatch : 'full'},
      {path : '**', redirectTo : '/home', pathMatch : 'full'}
    ]
  },

  //{path : '', redirectTo : '/login', pathMatch : 'full'},
  {path : '**', redirectTo : '/login', pathMatch : 'full'}
];
